var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTechOnekey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 106.987 28.23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "ONE KEY"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.402 25.071h.836v1.766c0 .3.013.81.779.81s.779-.508.779-.81v-1.766h.835v1.972c0 .344-.043 1.188-1.615 1.188s-1.615-.844-1.615-1.188Z",
  "data-name": "Path 4807"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.777 25.071h.809v3.075h-.908l-1.675-2.144h-.008v2.144h-.81v-3.075h.969l1.614 2.144h.009Z",
  "data-name": "Path 4808"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.174 25.071h.835v2.463h1.874v.612h-2.709Z",
  "data-name": "Path 4809"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.024 27.644a1.038 1.038 0 1 0-1.025-1.038.97.97 0 0 0 1.025 1.038m0-2.661c1.654 0 1.912.982 1.912 1.623s-.259 1.623-1.912 1.623-1.912-.982-1.912-1.623.259-1.623 1.912-1.623",
  "data-name": "Path 4810"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.947 26.232a.816.816 0 0 0-.879-.663 1.041 1.041 0 0 0 0 2.076.816.816 0 0 0 .879-.68h.909c-.1.9-.84 1.266-1.817 1.266-1.12 0-1.817-.482-1.817-1.623s.7-1.623 1.817-1.623c.741 0 1.684.19 1.809 1.249Z",
  "data-name": "Path 4811"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.523 25.071h1.124l-1.413 1.236 1.52 1.839h-1.128l-1.046-1.331-.487.418v.913h-.835v-3.075h.835v1.322Z",
  "data-name": "Path 4812"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.005 25.069h.835v3.075h-.835z",
  "data-name": "Rectangle 25195"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.019 25.071h.81v3.075h-.908l-1.675-2.144h-.009v2.144h-.81v-3.075h.969l1.615 2.144h.009Z",
  "data-name": "Path 4813"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.363 26.43h1.567v1.714h-.422l-.112-.358a1.72 1.72 0 0 1-1.292.443c-1.12 0-1.817-.482-1.817-1.623a1.607 1.607 0 0 1 1.817-1.623c.853 0 1.658.25 1.809 1.094h-.93a.76.76 0 0 0-.784-.508 1.038 1.038 0 0 0 0 2.076.81.81 0 0 0 .909-.68h-.745Z",
  "data-name": "Path 4814"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.92 25.655h-1.141v-.585h3.117v.586h-1.141v2.489h-.835Z",
  "data-name": "Path 4815"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.186 25.071h.836v1.154h1.731v-1.154h.835v3.075h-.835v-1.335h-1.731v1.335h-.836Z",
  "data-name": "Path 4816"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.176 25.071h2.872v.586h-2.036v.637h1.933v.56h-1.933v.706h2.054v.586h-2.89Z",
  "data-name": "Path 4817"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.956 27.559h.93c.552 0 .8-.332.8-.982 0-.568-.241-.921-.878-.921h-.853Zm-.835-2.489h1.916a1.539 1.539 0 0 1 .073 3.075h-1.989Z",
  "data-name": "Path 4818"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.028 25.069h.836v3.075h-.836z",
  "data-name": "Rectangle 25198"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.396 26.43h1.567v1.714h-.422l-.112-.358a1.72 1.72 0 0 1-1.292.443c-1.119 0-1.817-.482-1.817-1.623a1.607 1.607 0 0 1 1.817-1.623c.853 0 1.658.25 1.809 1.094h-.93a.76.76 0 0 0-.784-.508 1.038 1.038 0 0 0 0 2.076.81.81 0 0 0 .909-.68h-.745Z",
  "data-name": "Path 4819"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.516 25.069h.835v3.075h-.835z",
  "data-name": "Rectangle 25200"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.781 25.655h-1.142v-.585h3.118v.586h-1.141v2.489h-.835Z",
  "data-name": "Path 4820"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.391 25.733-.482 1.219h.965Zm.706 1.778h-1.412l-.25.633h-.9l1.353-3.075h1.007l1.353 3.075h-.9Z",
  "data-name": "Path 4821"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.48 25.071h.836v2.463h1.873v.612H71.48Z",
  "data-name": "Path 4822"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.714 25.071h.835v1.878c0 .53-.025 1.283-1.24 1.283-.714 0-1.378-.185-1.378-1.059v-.194h.835v.215a.435.435 0 0 0 .452.478c.435 0 .5-.258.5-.62Z",
  "data-name": "Path 4823"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.875 27.644a1.038 1.038 0 1 0-1.024-1.038.97.97 0 0 0 1.024 1.038m0-2.661c1.654 0 1.912.982 1.912 1.623s-.258 1.623-1.912 1.623-1.912-.982-1.912-1.623.258-1.623 1.912-1.623",
  "data-name": "Path 4824"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.037 27.559h1.231a.33.33 0 0 0 .357-.362c0-.241-.15-.37-.443-.37h-1.146Zm0-1.266H85.2a.29.29 0 0 0 .314-.332c0-.194-.086-.332-.431-.332h-1.046Zm-.835-1.223h2.308c.448 0 .866.207.866.775a.63.63 0 0 1-.409.616v.009a.72.72 0 0 1 .547.745c0 .409-.189.93-1.12.93h-2.192Z",
  "data-name": "Path 4825"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.112 25.96c-.052-.4-.435-.444-.771-.444s-.569.155-.569.362c0 .164.138.254.353.289l1.047.168c.559.09.986.3.986.861s-.388 1.033-1.6 1.033c-.749 0-1.723-.095-1.731-1.055h.938c.009.422.431.5.792.5.392 0 .658-.116.658-.383 0-.237-.189-.3-.521-.353l-.762-.116c-.534-.082-1.051-.241-1.051-.87 0-.685.56-.965 1.524-.965.634 0 1.573.108 1.629.978Z",
  "data-name": "Path 4826"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.543 25.069h.836v3.075h-.836z",
  "data-name": "Rectangle 25202"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.808 25.655h-1.141v-.585h3.118v.586h-1.141v2.489h-.836Z",
  "data-name": "Path 4827"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.076 25.071h2.872v.586h-2.037v.637h1.929v.56h-1.933v.706h2.054v.586h-2.889Z",
  "data-name": "Path 4828"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.513 27.41h.835v.732h-.835z",
  "data-name": "Rectangle 25203"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.885 25.708h-.115v-.582l-.228.582h-.073l-.228-.582v.582h-.115v-.7h.178l.208.529.2-.529h.177Zm-.909-.6h-.219v.6h-.114v-.6h-.219v-.093h.552Z",
  "data-name": "Path 4829"
}), /*#__PURE__*/React.createElement("path", {
  d: "m62.978 4.008.114.124-1.731 1.683-.119-.125a10.966 10.966 0 0 0-15.509-.147l-.057.053-1.67-1.714.062-.054a13.37 13.37 0 0 1 18.911.18",
  "data-name": "Path 4830"
}), /*#__PURE__*/React.createElement("path", {
  d: "m59.641 7.243.124.13-1.817 1.751-.109-.139a6.26 6.26 0 0 0-8.842-.076l-.059.061-1.73-1.778.061-.067a8.744 8.744 0 0 1 12.373.119",
  "data-name": "Path 4831"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.417 12.723a2.93 2.93 0 1 0-4 2.732l-1.684 6.477h5.548l-1.71-6.485a2.93 2.93 0 0 0 1.844-2.724",
  "data-name": "Path 4832"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.053 12.929c0-2.4-1.831-4.059-5.038-4.059s-5.037 1.654-5.037 4.059 1.832 4.06 5.037 4.06 5.038-1.654 5.038-4.06m-13.051 0c0-3.078 2.25-5.773 8.013-5.773s8.015 2.7 8.015 5.773-2.253 5.776-8.015 5.776-8.013-2.7-8.013-5.776",
  "data-name": "Path 4833"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.437 7.461h3.281l8.11 8.21h.037v-8.21h2.748v10.938h-3.225l-8.166-8.21h-.039v8.21h-2.747Z",
  "data-name": "Path 4834"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.137 7.461h11.83v1.716h-8.969v2.756h8.605v1.716h-8.605v3.033h9.121v1.716H33.137Z",
  "data-name": "Path 4835"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.084 7.609h2.992v5.071l7.287-5.071h4.112l-6.646 4.443 7.065 6.495h-4.051l-5.35-5.04-2.417 1.64v3.4h-2.992Z",
  "data-name": "Path 4836"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.347 7.609h12.377v1.716h-9.381v2.756h9v1.716h-9v3.033h9.54v1.716H78.347Z",
  "data-name": "Path 4837"
}), /*#__PURE__*/React.createElement("path", {
  d: "m97.763 14.379-6.226-6.77h3.652l4.071 4.872 4.073-4.872h3.652l-6.227 6.77v4.167h-3Z",
  "data-name": "Path 4838"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.986 18.707h-.167v-.845l-.331.845h-.106l-.331-.845h-.006v.845h-.166v-1.011h.258l.3.767.3-.767h.255Zm-1.312-.878h-.317v.876h-.166v-.876h-.317v-.134h.8Z",
  "data-name": "Path 4839"
}))));
export default SvgTechOnekey;